import React, { createContext, useState } from 'react';
import { useExperienceContext } from '../hooks/useContexts';
import { DateRanges } from '../utils/DateRanges';
export var BusinessToolsContext = createContext({
    jobSpends: [],
    setJobSpends: function () { return null; },
    dateSelectorValue: 'YTD',
    setDateSelectorValue: function () { return null; },
    requestData: {
        startDate: '',
        endDate: '',
    },
    setRequestData: function () { return null; },
    businessToolsHostName: '',
});
var BusinessToolsProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), jobSpends = _b[0], setJobSpends = _b[1];
    var _c = useState('YTD'), dateSelectorValue = _c[0], setDateSelectorValue = _c[1];
    var _d = useState(DateRanges.YTD), requestData = _d[0], setRequestData = _d[1];
    var configService = useExperienceContext().configService;
    var businessToolsHostName = (configService === null || configService === void 0 ? void 0 : configService.ENABLE_NEW_PURCHASE_HISTORY_PAGE) === '1'
        ? '/myaccount/purchase-history'
        : '/b2b/account/view/order/summary';
    return (React.createElement(BusinessToolsContext.Provider, { value: {
            jobSpends: jobSpends,
            setJobSpends: setJobSpends,
            dateSelectorValue: dateSelectorValue,
            setDateSelectorValue: setDateSelectorValue,
            requestData: requestData,
            setRequestData: setRequestData,
            businessToolsHostName: businessToolsHostName,
        } }, children));
};
export default BusinessToolsProvider;
